export default "__VITE_ASSET__T0s417jE__"